import { render, staticRenderFns } from "./PhotoCardForm.vue?vue&type=template&id=5c3aa764&scoped=true&"
import script from "./PhotoCardForm.vue?vue&type=script&lang=js&"
export * from "./PhotoCardForm.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCardForm.vue?vue&type=style&index=0&id=5c3aa764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3aa764",
  null
  
)

export default component.exports